<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <job-details-page />
    </div>
  </div>
</template>

<script>
import JobDetailsPage from '../Components/JobDetailsPage.vue';
export default {
  name: 'JobDetails',
  components: {
    'job-details-page': JobDetailsPage,
  },
};
</script>
